module.exports = __webpack_public_path__ + "static/img/42.bce4341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/42.png
// module id = hitb
// module chunks = 0